/**
 * groupPeople selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import groupBy from 'lodash.groupby';
import isEqual from 'lodash.isequal';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

interface State {
    groupPeople: {
        [string]: {
            id: number
        }
    };
}

interface Props {
    groupId?: number | string;
    personId?: number | string;
}

const selectGroupPeople = (state: State) => state.groupPeople;
const selectGroupId = (state: State, { groupId }: Props) =>
    groupId && Number(groupId);
const selectPersonId = (state: State, { personId }: Props) =>
    personId && Number(personId);

const selectData = createDeepEqualSelector(
    selectGroupPeople,
    groupPeopleState => groupPeopleState
);

const selectDataGroupedByGroupId = createDeepEqualSelector(
    selectGroupPeople,
    groupPeopleState => groupBy(groupPeopleState, 'groupId')
);

const selectDataGroupedByPersonId = createDeepEqualSelector(
    selectGroupPeople,
    groupPeopleState => groupBy(groupPeopleState, 'personId')
);

const makeSelectGroupPeopleIds = () =>
    createDeepEqualSelector(
        [selectDataGroupedByGroupId, selectGroupId],
        (dataGroupedByGroupIdState, groupIdState) => {
            if (!dataGroupedByGroupIdState) return undefined;
            const groupData = dataGroupedByGroupIdState[groupIdState];
            if (!groupData) return undefined;
            return groupData.map(value => value.personId);
        }
    );

const makeSelectPersonGroupIds = () =>
    createDeepEqualSelector(
        [selectDataGroupedByPersonId, selectPersonId],
        (dataGroupedByPersonIdState, personIdState) => {
            if (!dataGroupedByPersonIdState) return undefined;
            const personData = dataGroupedByPersonIdState[personIdState];
            if (!personData) return undefined;
            return personData.map(value => value.groupId);
        }
    );

export {
    selectGroupPeople,
    selectData,
    selectDataGroupedByGroupId,
    selectDataGroupedByPersonId,
    makeSelectGroupPeopleIds,
    makeSelectPersonGroupIds
};
